import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Aviso, Botao, Campo } from '../componentes/forma.tsx';
import { api, ErroApi } from '../lib/api.ts';
import './entrar.css';

export function TrocarSenha() {
  const [form, setForm] = useState({ atual: '', nova: '', confirmacao: '' });
  const [erro, setErro] = useState('');
  const [campos, setCampos] = useState<Record<string, string>>({});
  const [enviando, setEnviando] = useState(false);
  const qc = useQueryClient();
  const navegar = useNavigate();

  const mudar = (chave: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm({ ...form, [chave]: e.target.value });

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro('');
    setCampos({});
    setEnviando(true);
    try {
      await api.post('/auth/senha', form);
      await qc.invalidateQueries({ queryKey: ['sessao'] });
      navegar('/fila', { replace: true });
    } catch (e) {
      if (e instanceof ErroApi) {
        setCampos(e.campos);
        if (!e.temCampos) setErro(e.message);
      } else {
        setErro('Não foi possível trocar a senha.');
      }
      setEnviando(false);
    }
  }

  return (
    <div className="entrar">
      <div className="entrar__luz" aria-hidden="true" />
      <main className="entrar__painel">
        <header className="entrar__marca">
          <h1 className="entrar__nome">Defina sua senha</h1>
          <p className="entrar__sub">Primeiro acesso</p>
        </header>

        <form className="entrar__forma" onSubmit={(e) => void enviar(e)} noValidate>
          {erro && <Aviso>{erro}</Aviso>}

          <Campo
            rotulo="Senha atual"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={form.atual}
            erro={campos.atual}
            onChange={mudar('atual')}
          />
          <Campo
            rotulo="Nova senha"
            type="password"
            autoComplete="new-password"
            value={form.nova}
            erro={campos.nova}
            dica="Pelo menos 8 caracteres."
            onChange={mudar('nova')}
          />
          <Campo
            rotulo="Repita a nova senha"
            type="password"
            autoComplete="new-password"
            value={form.confirmacao}
            erro={campos.confirmacao}
            onChange={mudar('confirmacao')}
          />

          <Botao type="submit" variante="primario" carregando={enviando}>
            {enviando ? 'Salvando…' : 'Salvar senha'}
          </Botao>
        </form>
      </main>
    </div>
  );
}
